var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"mb-5"},[_c('Breadcrumb')],1),_c('router-view'),(_vm.lightboxVisible)?_c('Lightbox'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }